const binding = { modules: {}, dataActions: {} };

    (binding.modules['eshop-page-title'] = {
        c: () => require('partner/modules/eshop-page-title/eshop-page-title.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eshop-page-title',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eshop-page-title'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eshop-page-title|eshop-page-title'] = {
                c: () => require('partner/modules/eshop-page-title/eshop-page-title.view.tsx'),
                cn: '__local__-__local__-eshop-page-title'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };